/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Flex, Grid, Heading, jsx } from 'theme-ui'
import CallToAction from '~/components/Content/Section/CallToAction'

const SimpleContentCardListSection = ({ cards, description, title }) => {
  return (
    <Box bg="backgroundMedium" pt={[7, null, 9, 13]} pb={[8, null, 10, 14]}>
      <Container>
        {title && (
          <Grid columns={[null, 12]} sx={{ rowGap: 0 }}>
            <Box
              mb={[6, 7, null, 9]}
              sx={{
                gridColumn: [null, '1 / -1', '2 / 12', '3 / 11'],
                textAlign: 'center',
              }}
            >
              <Heading as="h2" variant="title2">
                {title}
              </Heading>
              {description && (
                <Box
                  mt={2}
                  dangerouslySetInnerHTML={{
                    __html: description.childMarkdownRemark.html,
                  }}
                  sx={{
                    p: { m: 0 },
                  }}
                />
              )}
            </Box>
          </Grid>
        )}
        {cards.map(({ media, title, subtitle, description, cta }, index) => (
          <Grid
            key={`card-${index}`}
            columns={[1, 12]}
            sx={{
              rowGap: 0,
              '&:not(:last-of-type)': { mb: [6, 7, 9, 6] },
            }}
          >
            <Box
              mb={[3, 0]}
              sx={{
                gridColumn:
                  index % 2 === 0
                    ? ['1 / -1', '1 / 6', '7 / -1', '8 / -1']
                    : ['1 / -1', '1 / 6', '1 / 7', '1 / 6'],
              }}
            >
              {media && (
                <GatsbyImage
                  image={media.gatsbyImageData}
                  alt={media.description}
                />
              )}
            </Box>
            <Flex
              sx={{
                height: '100%',
                flexDirection: 'column',
                gridColumn:
                  index % 2 === 0
                    ? ['1 / -1', '6 / -1', '1 / 7', '2 / 7']
                    : ['1 / -1', '6 / -1', '7 / -1', '7 / 12'],
                gridRow: [null, '1 / 2'],
                justifyContent: [null, 'flex-start', 'center'],
              }}
            >
              <Heading as="h3" variant="title3" mb={[1, null, 2]}>
                {title}
              </Heading>
              {subtitle && (
                <Heading as="h3" variant="subtitle1" mt={-1} mb={2}>
                  {subtitle}
                </Heading>
              )}
              {description && (
                <Box
                  variant="text.body2"
                  sx={{
                    'p:first-of-type, ul:first-of-type': {
                      mt: 0,
                    },
                    'p:last-of-type, ul:last-of-type': {
                      mb: 0,
                    },
                    a: {
                      variant: 'text.link',
                    },
                    'ul, ol': { pl: 4 },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: description.childMarkdownRemark.html,
                  }}
                />
              )}

              {cta && (
                <Box mt={2}>
                  <CallToAction content={cta} type="text" />
                </Box>
              )}
            </Flex>
          </Grid>
        ))}
      </Container>
    </Box>
  )
}

export default SimpleContentCardListSection
